<div *ngIf="showReload" class="retry">
    <i class="fa fa-repeat reload-icon" (click)="reload()"></i>
    <h4 class="validating mt-4">Reintentar</h4>
</div>
<app-loader-w-message *ngIf="validatingCredentials && !showReload" [loadingMessage]="loadingMessage"></app-loader-w-message>

<!-- MAIN -->
<app-lcv-cards-container *ngIf="!validatingCredentials" ></app-lcv-cards-container>
